import React from "react";
import { CellContext } from "@tanstack/react-table";

import { OverflowTooltip } from "@adsk/alloy-react-tooltip";

import CategoryName from "../../../components/CategoryName";
import { EntityWithCategoryAndStatus } from "../../../models";
import LoadingErrorCell from "../../AssetsPlugin/LoadingErrorCell";

const CategoryCell = <T,>({
  row,
}: CellContext<EntityWithCategoryAndStatus<T>, string>) => {
  return (
    <OverflowTooltip>
      {!row.original.category ? (
        <LoadingErrorCell />
      ) : (
        <CategoryName category={row.original.category} />
      )}
    </OverflowTooltip>
  );
};

export default CategoryCell;
